import React, { useEffect } from 'react';
import withApollo from 'lib/apollo';
import gql from 'graphql-tag';
import router from 'next/router';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { _Store, _StoreTokens } from '@netfront/gelada-react-shared';
import Icon from 'components/Icon';
import { AuthenticationLayout } from 'components/Layout/AuthenticationLayout';
import { Layout } from 'components/Layout/Layout';
import styles from 'components/Login/Login.module.css';
import { useQueryString } from 'lib/hooks/useQueryString';
import { client } from 'application/middleware/ekardo/ekardoClient';

const LOGIN = gql`
  query login($token: String!) {
    loginWithAuthenticationToken(token: $token) {
      token
      refreshToken
      user {
        id
        firstname
        created
        lastname
        communityName
        credential {
          email
        }
      }
    }
  }
`;

const Access = ({ query }) => {
  const { k } = useQueryString();
  const accessKey = k;

  const [sendQuery, { refetch }] = useLazyQuery(
    gql`
      query($userId: Int!) {
        user {
          checkUserAuthorizationByUserId(userId: $userId)
        }
      }
    `,
    {
      fetchPolicy: 'no-cache',
      client: client,
      onCompleted: (data) => {
        if (data.user.checkUserAuthorizationByUserId) {
          router.push('/dashboard');
        } else {
          setInterval(() => {
            refetch();
          }, 1000);
        }
      },
    },
  );

  useQuery(LOGIN, {
    skip: !accessKey,
    context: { clientName: 'auth' },
    variables: { token: accessKey },
    onCompleted(data) {
      if (!data) return;
      const {
        loginWithAuthenticationToken: { token, refreshToken, user },
      } = data;
      _Store(user, 'UserData');
      _StoreTokens(token, refreshToken);
      sendQuery({ variables: { userId: user.id } });
    },
    onError(error) {
      console.error(error);
      router.push('/');
    },
  });

  return (
    <div style={{ minWidth: '300px' }}>
      <Layout title="SHADE">
        <AuthenticationLayout
          heading={
            <>
              Log in to <span className="active uppercase">Shade</span>
            </>
          }
        >
          <div className={styles['details']}>
            <Icon hasBorder id="lock" size="lg" backgroundColor="aqua" fill="white" stroke="none" borderColor="none" />
            <p>Authenticating.. please wait...</p>
          </div>
        </AuthenticationLayout>
      </Layout>
    </div>
  );
};

Access.getInitialProps = ({ query }) => {
  return { query };
};

export default withApollo(Access, { ssr: false });
